// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"694e39fe","145":"0989be17","239":"ad40150f","453":"70431646","619":"f6d68eb5","660":"afc0b55e","722":"9ae0aa5c","732":"35ed01f5","863":"4b51210a","933":"872914a8","946":"e51dcf75"}[chunkId] + ".chunk.js";
};